/**
 * Secção "Recentemente vistos": lista do localStorage + /search?view=product.
 * Depende de global.js + base.js (teamdropInitProductCards) + product.js (utilities, wishlist).
 */

function getProducts(container) {
  if (!container || typeof theme === "undefined" || !theme.utilities) return;

  var e = theme.utilities.getListFromStorage(theme.storageKeys.recentViewedProduct);
  var productDetail = document.querySelector(".product-detail");
  var maxItems = parseInt(container.dataset.maxItem, 10) || 16;

  e = productDetail ? e.filter(function (id) {
    return id != productDetail.dataset.productId;
  }) : e;
  e = e.toReversed().slice(0, maxItems);

  if (e.length <= 0) {
    container.remove();
    return;
  }

  var q = e.map(function (id) {
    return "id:" + id;
  }).join(" OR ");
  var url = window.location.origin + "/search?view=product&q=" + q;

  fetch(url)
    .then(function (r) {
      return r.text();
    })
    .then(function (html) {
      var doc = new DOMParser().parseFromString(html, "text/html");
      var searchResult = doc.querySelector("#searchResult");
      if (!searchResult) return;
      var cards = searchResult.querySelectorAll(".product-card");

      var gridContainer = container.querySelector(".recent-viewed-product__grid");
      var swiperWrapper = container.querySelector(".swiper-wrapper");

      if (gridContainer) {
        gridContainer.innerHTML = "";
      } else if (swiperWrapper) {
        swiperWrapper.innerHTML = "";
      }

      var swiperFrag =
        swiperWrapper && typeof DocumentFragment !== "undefined"
          ? document.createDocumentFragment()
          : null;

      cards.forEach(function (productCard, index) {
        var clonedProduct = productCard.cloneNode(true);
        var productForm = clonedProduct.querySelector(".product-form");

        if (productForm) {
          var originalId = productForm.getAttribute("id");
          var newId = originalId + "-" + index;
          productForm.setAttribute("id", newId);
          clonedProduct.querySelectorAll('input[form="' + originalId + '"]').forEach(function (input) {
            input.setAttribute("form", newId);
          });
        }

        if (gridContainer) {
          var col = document.createElement("div");
          col.className = "col";
          col.appendChild(clonedProduct);
          gridContainer.appendChild(col);
        } else if (swiperWrapper) {
          var slide = document.createElement("div");
          slide.classList.add("swiper-slide");
          slide.appendChild(clonedProduct);
          if (swiperFrag) {
            swiperFrag.appendChild(slide);
          } else {
            swiperWrapper.appendChild(slide);
          }
        }
      });

      if (swiperFrag && swiperWrapper) {
        swiperWrapper.appendChild(swiperFrag);
      }

      theme.utilities.applyAnimation();
      if (theme.wishlist && theme.wishlist.setInWishlistProduct) {
        theme.wishlist.setInWishlistProduct();
      }
      teamdropInitProductCards(container);
    })
    .catch(function (err) {
      console.log(err);
    });
}

function mountRecentViewed(root) {
  (root || document).querySelectorAll(".recent-viewed-product").forEach(getProducts);
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", function () {
    mountRecentViewed(document);
  });
} else {
  mountRecentViewed(document);
}

document.addEventListener("shopify:section:load", function (event) {
  if (!event.target) return;
  var el = event.target.querySelector(".recent-viewed-product");
  if (el) getProducts(el);
});
